<div class="content-block">
    <app-header-banner [data]="banner"></app-header-banner>
    <div class="container">
       <img src="../../assets/images/management-chart.jpg" alt="">
    </div>
</div>